// HowToMessage.js
import React from 'react';

const HowToMessage = () => {
    return (
        <>
            <p>This calculator helps you estimate your new average price per unit when you invest additional funds into a stock you already hold. Here’s how to use the inputs:</p>
            <ol>
                <li><strong>Current Hold Units:</strong> Enter the total number of stock units you currently hold in your portfolio.</li>
                <li><strong>Average Price:</strong> Provide the average price at which you purchased your currently held units.</li>
                <li><strong>New Investment Amount:</strong> Input the additional amount of money you plan to invest in this stock.</li>
                <li><strong>Current Market Price:</strong> Enter the current market price of the stock.</li>
                <li><strong>Get the Result:</strong> Once you’ve entered all the inputs, click <strong>Evaluate</strong>.</li>
            </ol>
            <p>This feature helps you make informed decisions about cost-averaging your investments. Happy investing!</p>
        </>
    );
};

export default HowToMessage;
